export default __webpack_public_path__ + "static/media/PMR-Sunset-Round-350px.jpg.87d50f9c.webp";